import { useCallback, useEffect } from "react";
import { useSetRecoilState } from "recoil";

import { useGetCartQuery } from "graphql/generated";
import graphQLClient from "graphql/react-query";
import { cartState, orderCalculationState } from "src/states";

const useSyncCartHook = (shouldReturnCalculation = true, shouldFetchCart = true) => {
  const setCart = useSetRecoilState(cartState);
  const setOrderCalculation = useSetRecoilState(orderCalculationState);
  const {
    data: cartData,
    refetch,
    isLoading
  } = useGetCartQuery(
    graphQLClient,
    {
      input: {
        shouldReturnCalculation
      }
    },
    { enabled: shouldFetchCart, refetchOnWindowFocus: true }
  );

  const updateCartAndCalculation = useCallback(() => {
    const cartFromDB = cartData?.getCart;
    if (!cartFromDB) {
      return;
    }

    setCart({ ...cartFromDB, isLoading: false });

    if (cartFromDB?.calculation) {
      setOrderCalculation(cartFromDB.calculation);
    }
  }, [cartData?.getCart, setCart, setOrderCalculation]);

  useEffect(() => {
    updateCartAndCalculation();
  }, [cartData, updateCartAndCalculation]);

  return { refetch, isLoading };
};

export default useSyncCartHook;
